import { SVGProps, Ref, forwardRef } from 'react';

export const Diagram100Size24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.57 6.277C4.362 7.727 3.8 9.767 3.8 12s.562 4.272 1.77 5.723C6.73 19.115 8.683 20.2 12 20.2s5.27-1.085 6.43-2.477c1.208-1.45 1.77-3.49 1.77-5.723s-.562-4.272-1.77-5.723C17.27 4.885 15.317 3.8 12 3.8S6.73 4.885 5.57 6.277M12 2C4.5 2 2 7 2 12s2.5 10 10 10 10-5 10-10S19.5 2 12 2"
                fill="currentColor"
            />
        </g>
    </svg>
));
Diagram100Size24Glyph.displayName = 'Diagram100Size24Glyph';
